import React, { useState } from "react";
import "../assets/css/AboutVideoSection.css";
import videoThumb from "../assets/images/Corporate-video-tumbnail.png";
import companyVideo from "../assets/Video/Geobio family _ Corporate video.mp4";

const AboutVideoSection = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <section className="video-section mt-5 mb-5" data-aos="zoom-in">
      <div className="container text-center">
        <div className="video-wrapper">
          <img
            src={videoThumb}
            alt="Company Video"
            className="video-thumbnail"
          />
          <div className="play-button" onClick={handleOpen}>
            <i className="bi bi-play-fill"></i>
          </div>
        </div>
      </div>

      {/* ===== Video Modal ===== */}
      {showModal && (
        <div className="video-modal-overlay" onClick={handleClose}>
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <button className="close-modal" onClick={handleClose}>
              &times;
            </button>
            <video
              src={companyVideo}
              className="video-modal-player"
              controls
              autoPlay
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutVideoSection;
